/**
 * Runtime environment detection and configuration
 */

export interface RuntimeEnv {
  readonly mode: "tauri" | "http";
  readonly isTauri: boolean;
  readonly isDev: boolean;
  readonly apiUrl: string;
}

/**
 * Detect the current runtime environment
 */
export function detectEnv(): RuntimeEnv {
  const isTauri = "__TAURI__" in window || "__TAURI_INTERNALS__" in window;
  const isDev = import.meta.env.DEV;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/prefer-nullish-coalescing
  const apiUrl = import.meta.env.VITE_API_URL || (isDev ? window.location.origin : "http://localhost:3000");

  return {
    mode: isTauri ? "tauri" : "http",
    isTauri,
    isDev,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    apiUrl,
  };
}
